import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import NanoFlex from "../../../Global/NanoFlex.js";
import { buildColumnsLinesPivot, buildPivotColumnsLines, buildPivotLines, buildPivotColumns, convertElementsToTree, getDateTime } from "../../../Global/tools.js";
import pivotService from "./../../../../services/PivotService";
import moment from "moment";

// COMPONENTS
import Loading from "../../../Global/Elements/Loading/Loading.js";
import { Filters } from "./../Dynamique/Filters.js";
import { RecapFilters } from "./../Grid/RecapFilters.js";
import { OptionsFilters } from "./OptionsFilters.js";
import { Timeline } from "./../Grid/Timeline.js";
import { Pivot } from "./../Pivot/Pivot.js";

const StyledSvod = styled(NanoFlex)`
  min-width: 0;
  .svodContent {
    padding: 32px;
    min-width: 0;
    .dynamiqueWrapper {
      .pivot {
        /* height: ${(props) => (props.showWordCloud ? "calc(100vh - 470px)" : "calc(100vh - 206px)")}; */
        .pivotConfiguration {
          display: none;
        }
        .pivotTable {
          margin-top: 0;
        }
      }
    }
  }
`;

export class Svod extends BaseComponent {
  constructor(props, prevProps) {
    super(props, prevProps);

    let prevColumns = null;
    let prevLines = null;
    let prevFilters = null;
    let prevStart = null;
    let prevEnd = null;

    if (window.location.pathname === sessionStorage.getItem("lastPathname") || sessionStorage.getItem("lastPathname") === "/librairies") {
      prevColumns = JSON.parse(sessionStorage.getItem("jsonColumnsByReport"));
      prevLines = JSON.parse(sessionStorage.getItem("jsonLinesByReport"));
      prevFilters = JSON.parse(sessionStorage.getItem("filtersByReport"));
      prevStart = prevFilters?.startTime ? moment(prevFilters.startTime) : null;
      prevEnd = prevFilters?.endTime ? moment(prevFilters.endTime) : null;
    }

    this.state = {
      filter: prevFilters ?? null,
      start:
        prevFilters !== null && prevFilters.startTime && new Date(prevFilters.startTime).getHours() !== 0
          ? moment()
              .startOf("day")
              .set("hour", prevStart?.hour() ?? 0)
              .set("minute", prevStart?.minute() ?? 0)
              .toDate()
          : moment().startOf("day").set("hour", 0).toDate(),
      end:
        prevFilters !== null && prevFilters.endTime && new Date(prevFilters.endTime).getHours() !== 0
          ? moment()
              .startOf("day")
              .set("hour", prevEnd?.hour() ?? 0)
              .set("minute", prevEnd?.minute() ?? 0)
              .toDate()
          : moment().startOf("day").set("hour", 24).toDate(),
      results: null,
      loading: false,
      pivotLoading: false,
      pivotSettingsLoading: false,
      isConfigurationCollapsed: true,
      selectedTreeColumns: prevColumns !== null ? convertElementsToTree(prevColumns.elements) : [],
      selectedTreeLines: prevLines !== null ? convertElementsToTree(prevLines.elements) : [],
      hideCounts: prevFilters?.viewDetails ?? false,
      diffusionsSelected: [],
      selectedView: prevFilters?.selectedView != 0 && prevFilters?.selectedView != null ? prevFilters?.selectedView : 2,
    };

    if (this.state.filter) {
      this.state.filter.minTimeline = moment(this.state.start).set("hour", 0).toDate();
      this.state.filter.maxTimeline = moment(this.state.start).set("hour", 24).toDate();
    }

    this._requestId = 1;
    sessionStorage.setItem("lastPathname", window.location.pathname);
  }

  componentDidMount() {
    super.componentDidMount();
    if (sessionStorage.getItem("jsonColumnsByReport") === null && sessionStorage.getItem("jsonLinesByReport") === null) {
      this.getPivotSettings();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    var timeChanged =
      prevState.filter?.minTimeline &&
      prevState.filter?.maxTimeline &&
      (prevState.filter.minTimeline.getTime() !== this.state.filter.minTimeline.getTime() || prevState.filter.maxTimeline.getTime() !== this.state.filter.maxTimeline.getTime()) &&
      this.state.start.getTime() === prevState.filter.minTimeline.getTime() &&
      this.state.end.getTime() === prevState.filter.maxTimeline.getTime();
    if (timeChanged) {
      this.setState({ start: this.state.filter.minTimeline, end: this.state.filter.maxTimeline });
    }

    if (
      (JSON.stringify(prevState.filter) !== JSON.stringify(this.state.filter) && this.state.pivotSettingsLoading === false) ||
      prevState.hideCounts !== this.state.hideCounts ||
      JSON.stringify(prevState.diffusionsSelected) !== JSON.stringify(this.state.diffusionsSelected) ||
      JSON.stringify(prevState.selectedView) !== JSON.stringify(this.state.selectedView)
    ) {
      if (this.state.filter) {
        if (!timeChanged) {
          this.getPivotEmissions();
        }
      } else {
        this.setState({ results: null });
      }
    }

    if (JSON.stringify(prevState.selectedTreeColumns) !== JSON.stringify(this.state.selectedTreeColumns) || JSON.stringify(prevState.selectedTreeLines) !== JSON.stringify(this.state.selectedTreeLines)) {
      /*Ignore 1sec timeout on first load!*/
      if (this.state.pivotSettingsLoading) {
        this.setState({ pivotSettingsLoading: false }, () => {
          if (this.state.filter) {
            this.getPivotEmissions();
          }
        });
      } else {
        this._requestId++;
        var requestId = this._requestId;
        setTimeout(() => {
          if (requestId === this._requestId) {
            if (this.state.filter) {
              this.getPivotEmissions();
            }
          }
        }, 1000);
      }
    }

    if (JSON.stringify(prevState.start) !== JSON.stringify(this.state.start) || JSON.stringify(prevState.end) !== JSON.stringify(this.state.end)) {
      /*Dont Refresh if pivot settings is loading!*/
      if (!this.state.pivotSettingsLoading) {
        if (this.state.filter) {
          this.getPivotEmissions();
        }
      }
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  getFilter = () => {
    return {
      ...this.state.filter,
      ...{
        filterRecap: this.getTranslatedRecapFilters(this.state.filter.filterRecap),
        columnsLines: JSON.stringify(buildPivotColumnsLines(this.state.selectedTreeColumns, this.state.selectedTreeLines, "svod")),
        columns: JSON.stringify(buildPivotColumns(this.state.selectedTreeColumns)),
        lines: JSON.stringify(buildPivotLines(this.state.selectedTreeLines)),
        hideCounts: this.state.hideCounts,
        diffusionsSelected: this.state.diffusionsSelected,
        startTime: getDateTime(this.state.start),
        endTime: getDateTime(this.state.end),
        selectedSvodView: this.state.selectedView,
        isSvod: true,
      },
    };
  };

  getPivotSettings = () => {
    this.setState({ pivotSettingsLoading: true }, () => {
      pivotService
        .getPivotSettings("TVReplay")
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          let settings = buildColumnsLinesPivot(JSON.parse(data));
          this.setState({ selectedTreeColumns: settings.columns, selectedTreeLines: settings.lines });
        });
    });
  };

  getPivotEmissions = (firstLoad) => {
    this.setState({ loading: firstLoad ? true : false, pivotLoading: firstLoad ? false : true }, () => {
      pivotService
        .getPivotEmissions(this.getFilter())
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ results: data, loading: false, pivotLoading: false });
          //sessionStorage.removeItem("filtersByReport");
          sessionStorage.removeItem("jsonLinesByReport");
          sessionStorage.removeItem("jsonColumnsByReport");
        });
    });
  };

  render() {
    let loading = !this.state.filter || this.state.loading;
    let pivotSettingsSelected = JSON.stringify(buildPivotColumnsLines(this.state.selectedTreeColumns, this.state.selectedTreeLines, "emissions").categories);

    return (
      <StyledSvod justifyContent="flex-start">
        <Filters filtersSelected={this.state.filter} onFilterChange={(f) => this.setState({ filter: f })} isActive={this.state.filter ? true : false} isSvod />
        <NanoFlex className="svodContent">
          {loading && (
            <NanoFlex clasName="dynamiqueWrapper">
              <Loading />
            </NanoFlex>
          )}
          {!loading && (
            <NanoFlex className="dynamiqueWrapper" flexDirection="column" justifyContent="flex-start">
              <RecapFilters selectedFilters={this.getFilter()} />
              <OptionsFilters
                selectedInterval={[moment(this.state.start).format("HH:mm"), moment(this.state.end).format("HH:mm")]}
                filtersSelected={this.getFilter()}
                pivotSettings={pivotSettingsSelected}
                hasData={this.state.results?.result?.rows.length > 0}
                hideCounts={this.state.hideCounts}
                isSvod
                onHideCountsChange={(h) => this.setState({ hideCounts: h })}
                diffusions={this.state.results?.diffusions}
                diffusionsSelected={this.state.diffusionsSelected}
                onDiffusionsSelectedChange={(d) => this.setState({ diffusionsSelected: d })}
                onSelectedViewChange={(q) => this.setState({ selectedView: q })}
                selectedView={this.state.selectedView}
              />
              <Timeline selectedInterval={[this.state.start, this.state.end]} timelineInterval={[this.state.filter.minTimeline, this.state.filter.maxTimeline]} onChangeCallback={(intervals) => this.setState({ start: intervals[0], end: intervals[1] })} />
              <Pivot
                loading={this.state.pivotLoading || this.state.pivotSettingsLoading}
                selectedTreeColumns={this.state.selectedTreeColumns}
                selectedTreeLines={this.state.selectedTreeLines}
                onSelectedTreeChange={(columns, lines) => this.setState({ selectedTreeColumns: columns, selectedTreeLines: lines })}
                data={this.state.results}
              />
            </NanoFlex>
          )}
        </NanoFlex>
      </StyledSvod>
    );
  }
}
